/**
 * This files provide the constants for post excerpt
 *
 * @since 3.26.0
 * @author Naveen Muthusamy <naveen@wordlift.io>
 */

export const POST_EXCERPT_LOCALIZATION_OBJECT_KEY = "_wlExcerptSettings";
